import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function UserSurfacePager({
  page,
  totalPages,
  total,
  startIndex,
  endIndex,
  loading,
  onPageChange,
  emptyLabel = "No items",
}) {
  if (!total || totalPages <= 1) return null;

  return (
    <div className="au-user-index-foot">
      <span className="au-user-index-foot-meta">
        {total === 0 ? emptyLabel : `${startIndex + 1}–${endIndex} of ${total}`}
      </span>
      <div className="au-user-index-pager">
        <button
          type="button"
          className="au-user-pager-btn"
          disabled={page === 1 || loading}
          onClick={() => onPageChange(Math.max(page - 1, 1))}
          aria-label="Previous page"
        >
          <ChevronLeft size={14} aria-hidden />
        </button>
        <span className="au-user-pager-label">
          {page} / {totalPages}
        </span>
        <button
          type="button"
          className="au-user-pager-btn"
          disabled={page === totalPages || loading}
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
          aria-label="Next page"
        >
          <ChevronRight size={14} aria-hidden />
        </button>
      </div>
    </div>
  );
}

export const SURFACE_PAGE_SIZE = 20;
